import { action } from 'satcheljs';

// Action which is called when alwaysEncrypt option is changed.
export const onSmimeEncryptChanged = action('onSmimeEncryptChanged', (selectedOption: boolean) => ({
    selectedOption,
}));

// Action which is called when alwaysSign option is changed.
export const onSmimeSignChanged = action('onSmimeSignChanged', (selectedOption: boolean) => ({
    selectedOption,
}));

// Action which is called when manuallyPickCertificate option is changed.
export const onManuallyPickCertificateChanged = action(
    'onManuallyPickCertificateChanged',
    (selectedOption: boolean) => ({ selectedOption })
);

// Action which is called to discard S/MIME option changes.
export const discardSmimeOptions = action('discardSmimeOptions');

// Action which is called when signing certificate is selected by the user
export const onSigningCertificateChanged = action(
    'onSigningCertificateChanged',
    (signingCertificateId: string, signingCertificateSubject: string) => ({
        signingCertificateId,
        signingCertificateSubject,
    })
);
